import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { GoogleAnalytics } from "./components/GoogleAnalytics";
import App from "./App";
import { resolveAppBasePath } from "./lib/url";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={resolveAppBasePath()}>
      <GoogleAnalytics />
      <App />
    </BrowserRouter>
  </StrictMode>
);
